import type { Session } from './contract.gen'

type Listener = (signedIn: boolean) => void

/** Session store: the access token lives only in memory, the refresh token
 *  in localStorage (cookies are unreliable inside VK and Yandex iframes). */
export class SessionStore {
  private access: string | null = null
  private accountId: number | null = null
  private listeners = new Set<Listener>()
  constructor(private readonly key: string) {}

  get accessToken(): string | null {
    return this.access
  }

  get account(): number | null {
    return this.accountId
  }

  get refreshToken(): string | null {
    try {
      return localStorage.getItem(this.key)
    } catch {
      return null
    }
  }

  set(s: Session): void {
    this.access = s.access_token
    this.accountId = s.account_id
    try {
      localStorage.setItem(this.key, s.refresh_token)
    } catch {
      /* private mode: the session lasts until the tab closes */
    }
    this.emit(true)
  }

  clear(): void {
    this.access = null
    this.accountId = null
    try {
      localStorage.removeItem(this.key)
    } catch {
      /* ignore */
    }
    this.emit(false)
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn)
    return () => this.listeners.delete(fn)
  }

  private emit(v: boolean) {
    for (const fn of this.listeners) fn(v)
  }
}
